import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation } from "swiper/modules";
import "./slider.css";
import "./homepageslider.css";
import norepeate from "../assets/homepageslider/1.png";
import nocold from "../assets/homepageslider/2.png";
import notime from "../assets/homepageslider/3.png";
import { HiArrowSmallRight } from "react-icons/hi2";
import { HiArrowSmallLeft } from "react-icons/hi2";

const TestimonialSlider = () => {
  return (
    <div className="relative mx-width-[100px]">
      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: ".custom-swiper-button-next",
          prevEl: ".custom-swiper-button-prev",
        }}
        spaceBetween={20}
        breakpoints={{
          768: { slidesPerView: 1 },
          0: { slidesPerView: 1 },
        }}
      >
        <div className="whychoosesledediv" id="homepagesliser">
          {/* Testimonial Slide 1 */}
          <SwiperSlide className="slideparenthome">
            <div className="homepageslide1 homepageslide11">
              <div className="dec">
                <h3>Fresh Flavors Every Day</h3>
                <p>
                  No repeated recipes—savor a new, delicious meal with every
                  order!
                </p>
              </div>
              <img src={norepeate} alt="norepeate" loading="lazy" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="slideparenthome">
            <div className="homepageslide1 homepageslide12">
              <div className="dec">
                <h3>Always Fresh, Never Cold</h3>
                <p>
                  Enjoy warm, freshly prepared meals delivered straight from our
                  kitchen to your table!
                </p>
              </div>
              <img src={nocold} alt="no cold food" loading="lazy" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="slideparenthome">
            <div className="homepageslide1 homepageslide13">
              <div className="dec">
                <h3>Fresh Meals, Zero Compromise</h3>
                <p>
                  Say goodbye to boring, repetitive recipes—enjoy unique,
                  delicious meals every time!
                </p>
              </div>
              <img src={notime} alt="notime" loading="lazy" />
            </div>
          </SwiperSlide>
        </div>
      </Swiper>

      {/* Custom Navigation Buttons */}
      <div className="custom-swiper-button-prev">
        <HiArrowSmallLeft className="homesliderarr" />
      </div>
      <div className="custom-swiper-button-next">
        <HiArrowSmallRight className="homesliderarr" />
      </div>
    </div>
  );
};

export default TestimonialSlider;
